import Editor from './components/editor'
import cloneFragment from './utils/clone-fragment'
import findDOMNode from './utils/find-dom-node'
import findDOMPoint from './utils/find-dom-point'
import findDOMRange from './utils/find-dom-range'
import findNode from './utils/find-node'
import findPath from './utils/find-path'
import findPoint from './utils/find-point'
import findRange from './utils/find-range'
import getEventRange from './utils/get-event-range'
import getEventTransfer from './utils/get-event-transfer'
import setEventTransfer from './utils/set-event-transfer'
import ReactPlugin from './plugins/react'

/**
 * Export.
 *
 * @type {Object}
 */

export {
  Editor,
  cloneFragment,
  findDOMNode,
  findDOMPoint,
  findDOMRange,
  findNode,
  findPath,
  findPoint,
  findRange,
  getEventRange,
  getEventTransfer,
  setEventTransfer,
  ReactPlugin,
}

export default {
  Editor,
  cloneFragment,
  findDOMNode,
  findDOMPoint,
  findDOMRange,
  findNode,
  findPath,
  findPoint,
  findRange,
  getEventRange,
  getEventTransfer,
  setEventTransfer,
  ReactPlugin,
}
